<div class="flex items-center gap-8 w-full mb-24">
  <div class="relative flex flex-1" id="mach-core-flyout-search-input-wrapper">
    <input
      class="single-line-input w-icon peer w-full"
      id="mach-core-site-search-input"
      placeholder=" "
      [(ngModel)]="searchTerm"
      (input)="onSearchInput($event)"
      (keydown.enter)="submitSearch()"
      [maxlength]="content.maxCharacterCount || 300"
      [attr.aria-label]="content.submitSearch.placeHolderText"
    />
    <label for="mach-core-site-search-input" class="floating-title">
      {{ content.submitSearch.placeHolderText }}
    </label>
    @if (searchTerm.length > 0) {
      <button
        class="absolute right-12 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center !cursor-pointer"
        type="button"
        (click)="onClearSearch()"
        aria-label="Clear search"
        id="mach-core-flyout-search-clear-button"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 4L4 12M4 4L12 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    }
  </div>
  <button
    class="button button-icon cursor-pointer flex-shrink-0 border-none !bg-transparent active:!bg-transparent hover:!bg-transparent"
    tabindex="0"
    role="button"
    aria-label="Search"
    (click)="submitSearch()"
    id="mach-core-flyout-search-submit-button"
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.53564 7.61158C2.53564 4.96869 4.68637 2.81807 7.32939 2.81807C9.97241 2.81807 12.1231 4.96869 12.1231 7.61158C12.1231 10.2545 9.97241 12.4043 7.32939 12.4043C4.68637 12.4043 2.53564 10.2545 2.53564 7.61158ZM16.5938 16.0753L11.8968 11.3794C12.7442 10.3545 13.2535 9.04157 13.2535 7.61159C13.2535 4.34491 10.5959 1.6875 7.32985 1.6875C4.0638 1.6875 1.40625 4.34491 1.40625 7.61159C1.40625 10.8775 4.0638 13.5349 7.32985 13.5349C8.75991 13.5349 10.0729 13.0249 11.0979 12.1783L15.7948 16.875L16.5938 16.0753Z"
        fill="#001E3C"
      />
      <path
        d="M16.5938 16.0753L16.7706 16.252L16.9472 16.0752L16.7705 15.8985L16.5938 16.0753ZM11.8968 11.3794L11.7042 11.2201L11.5592 11.3954L11.7201 11.5562L11.8968 11.3794ZM11.0979 12.1783L11.2746 12.0016L11.1139 11.8408L10.9387 11.9856L11.0979 12.1783ZM15.7948 16.875L15.618 17.0518L15.7949 17.2286L15.9717 17.0517L15.7948 16.875ZM2.53564 7.61158H2.78564C2.78564 5.10678 4.82443 3.06807 7.32939 3.06807V2.81807V2.56807C4.54831 2.56807 2.28564 4.83061 2.28564 7.61158H2.53564ZM7.32939 2.81807V3.06807C9.83435 3.06807 11.8731 5.10678 11.8731 7.61158H12.1231H12.3731C12.3731 4.83061 10.1105 2.56807 7.32939 2.56807V2.81807ZM12.1231 7.61158H11.8731C11.8731 10.1163 9.8344 12.1543 7.32939 12.1543V12.4043V12.6543C10.1104 12.6543 12.3731 10.3926 12.3731 7.61158H12.1231ZM7.32939 12.4043V12.1543C4.82438 12.1543 2.78564 10.1163 2.78564 7.61158H2.53564H2.28564C2.28564 10.3926 4.54837 12.6543 7.32939 12.6543V12.4043ZM16.5938 16.0753L16.7705 15.8985L12.0736 11.2026L11.8968 11.3794L11.7201 11.5562L16.417 16.2521L16.5938 16.0753ZM11.8968 11.3794L12.0895 11.5387C12.9725 10.4708 13.5035 9.10201 13.5035 7.61159H13.2535H13.0035C13.0035 8.98114 12.516 10.2383 11.7042 11.2201L11.8968 11.3794ZM13.2535 7.61159H13.5035C13.5035 4.20685 10.734 1.4375 7.32985 1.4375V1.6875V1.9375C10.4578 1.9375 13.0035 4.48297 13.0035 7.61159H13.2535ZM7.32985 1.6875V1.4375C3.92572 1.4375 1.15625 4.20685 1.15625 7.61159H1.40625H1.65625C1.65625 4.48297 4.20188 1.9375 7.32985 1.9375V1.6875ZM1.40625 7.61159H1.15625C1.15625 11.0156 3.92574 13.7849 7.32985 13.7849V13.5349V13.2849C4.20186 13.2849 1.65625 10.7394 1.65625 7.61159H1.40625ZM7.32985 13.5349V13.7849C8.82043 13.7849 10.1892 13.2531 11.2571 12.3711L11.0979 12.1783L10.9387 11.9856C9.95665 12.7967 8.69939 13.2849 7.32985 13.2849V13.5349ZM11.0979 12.1783L10.9211 12.3551L15.618 17.0518L15.7948 16.875L15.9716 16.6982L11.2746 12.0016L11.0979 12.1783ZM15.7948 16.875L15.9717 17.0517L16.7706 16.252L16.5938 16.0753L16.4169 15.8986L15.6179 16.6983L15.7948 16.875Z"
        fill="#001E3C"
      />
    </svg>
  </button>
</div>

<div class="grid" id="mach-core-flyout-search-popular-section">
  <h2
    class="text-label-md-semibold text-heading mb-24"
    id="mach-core-flyout-search-popular-title"
  >
    {{ content.popularSearchTitle }}
  </h2>
  <ul class="grid gap-16" id="mach-core-flyout-search-popular-list">
    @for (topic of content.contentPopularSearch; track topic; let i = $index) {
      <li id="mach-core-flyout-search-popular-item-{{ i }}">
        <a
          class="text-label-sm-semibold text-link"
          draggable="false"
          [attr.href]="topic.populartopicsLink"
          [innerHTML]="topic.populartopicsTitle"
          (click)="getSelectedValue(topic.populartopicsLink)"
          id="mach-core-flyout-search-popular-link-{{ i }}"
        ></a>
      </li>
    }
  </ul>
</div>
